import Vue from 'vue'
// import VueCookies from 'vue-cookies'

import App from '@/app.vue'
import router from '@/router'
import store from '@/store'


Vue.config.productionTip = false
Vue.prototype.$global = {}


new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
